export default __webpack_public_path__ + "b47f3f90e879eb2349d51758eac2859d.svg";